import React from 'react';
import type { Customer, LoyaltyReward } from '../../types';
import GiftIcon from '../icons/GiftIcon';

interface RewardRedemptionModalProps {
  customer: Customer;
  rewards: LoyaltyReward[];
  onSelect: (reward: LoyaltyReward) => void;
  onClose: () => void;
}

const RewardRedemptionModal: React.FC<RewardRedemptionModalProps> = ({ customer, rewards, onSelect, onClose }) => {
  const availableRewards = rewards.filter(r => customer.loyaltyPoints >= r.pointsRequired);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md flex flex-col" style={{height: '80vh'}}>
        <header className="p-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Redeem a Reward</h2>
          <p className="text-sm text-gray-600">
            {customer.name} has <span className="font-bold text-pink-500">{customer.loyaltyPoints}</span> points.
          </p>
        </header>
        <main className="flex-1 overflow-y-auto p-4">
          {availableRewards.length > 0 ? (
            <ul>
              {availableRewards.map(reward => (
                <li key={reward.id}>
                  <button
                    onClick={() => onSelect(reward)}
                    className="w-full text-left p-4 mb-2 rounded-md hover:bg-gray-100 border flex justify-between items-center"
                  >
                    <div>
                      <p className="font-semibold text-gray-800">{reward.name}</p>
                      <p className="text-sm text-green-600 font-bold">Value: ${reward.discountValue.toFixed(2)}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-semibold text-pink-500">{reward.pointsRequired} pts</p>
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <div className="h-full flex items-center justify-center">
                <p className="text-gray-500">Not enough points for any rewards.</p>
            </div>
          )}
        </main>
        <footer className="p-4 border-t flex justify-end">
            <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
                Cancel
            </button>
        </footer>
      </div>
    </div>
  );
};

export default RewardRedemptionModal;